import { documentKind, type IDocument, type TDocumentKind } from '@apis/documents';
import { CadIcon, DocumentIcon, FilePdfIcon, FileSheetIcon, ImageIcon } from '@/utils/icons';
import styles from './FileTypeIcon.module.css';

const KIND_ICONS: Record<TDocumentKind, (props: { size?: number }) => React.ReactElement> = {
  image: ImageIcon,
  pdf: FilePdfIcon,
  sheet: FileSheetIcon,
  cad: CadIcon,
  doc: DocumentIcon,
  other: DocumentIcon,
};

export interface IFileTypeIconProps {
  doc: Pick<IDocument, 'name' | 'id'>;
  size?: number;
}

/**
 * The glyph a document leads with. Shape carries the file family and colour
 * reinforces it, so a folder of mixed uploads is scannable without reading
 * every filename.
 */
export function FileTypeIcon({ doc, size = 16 }: IFileTypeIconProps) {
  const kind = documentKind(doc);
  const Icon = KIND_ICONS[kind];

  return (
    <span className={`${styles.icon} ${styles[kind]}`} data-kind={kind} aria-hidden="true">
      <Icon size={size} />
    </span>
  );
}
